import "../css/cv.css";

function Cv() {
  return (
    <div className="cv-container">
      <p>Lives and works in Brooklyn, NY</p>
      <p></p>
      <p className="cv-subheader">EDUCATION </p>
      <p>2022 BFA, The Cooper Union, New York, NY</p>
      <p></p>
      <p></p>
      <p className="cv-subheader">EXHIBITIONS</p>
      <p>2022 Gestation Drive, The Cooper Union, New York, NY</p>
      <p>2021 Spine of the Earth, Burren College of Art, Ballyvaughan, Ireland</p>
      <p></p>
      <p></p>
      <p className="cv-subheader">RESIDENCIES</p>
      <p>2021 Burren College of Art Immersion Residency, Ballyvaughan, Ireland</p>
      <p></p>
      <p></p>
      <p className="cv-subheader">SCHOLARSHIPS & AWARDS</p>
      <p>2026 Penland School of Craft Merit Scholarship</p>
      <p>2019 School of Art Tuition Fund, The Cooper Union, New York, NY</p>
      <p>2018 Ismar David Scholarship, The Cooper Union, New York, NY</p>
      <p>2017 Robert Rauschenberg Award, Big Arts, Sanibel, FL</p> 
      <p>2017 Innovator Merit Award, The Cooper Union, New York, NY</p>
      <p></p>
      <p></p>
      <a href="mailto:someone@example.com">dowling.fe@gmail.com </a>
    </div>
  );
}

export default Cv;
